// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchContainer__Zzms {
  display: flex;
  gap: 10px;
}
.searchInputWrapper_YH0DH {
  display: flex;
  align-items: center;
  background: var(--white-background);
  width: 100%;
  min-height: 36px;
  border: 1px solid var(--d9d9e3-border);
  border-radius: 8px;
}
.searchIconsWrappers_XJv3S {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: var(--ececf1-background);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 3px;
}

.searchInput_c2466 {
  flex: 1 1;
  padding: 8px;
  border: none;
  background: transparent;
  font-size: 14px;
  outline: none;
}

.searchInput_c2466::placeholder {
  color: var(--_6-color);
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/CustomSearchbar/CustomSearchbar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".searchContainer {\n  display: flex;\n  gap: 10px;\n}\n.searchInputWrapper {\n  display: flex;\n  align-items: center;\n  background: var(--white-background);\n  width: 100%;\n  min-height: 36px;\n  border: 1px solid var(--d9d9e3-border);\n  border-radius: 8px;\n}\n.searchIconsWrappers {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  background: var(--ececf1-background);\n  cursor: pointer;\n  user-select: none;\n  border-radius: 3px;\n}\n\n.searchInput {\n  flex: 1;\n  padding: 8px;\n  border: none;\n  background: transparent;\n  font-size: 14px;\n  outline: none;\n}\n\n.searchInput::placeholder {\n  color: var(--_6-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchContainer": `searchContainer__Zzms`,
	"searchInputWrapper": `searchInputWrapper_YH0DH`,
	"searchIconsWrappers": `searchIconsWrappers_XJv3S`,
	"searchInput": `searchInput_c2466`
};
export default ___CSS_LOADER_EXPORT___;
